import { get } from 'lodash';

import {
  UPDATE_LOADING,
  UPDATE_ERROR,
  UPDATE_MESSAGE,
  SET_AUTH_DATA,
  SET_USER_TOKEN,
  UPDATE_USER_AVATAR,
} from 'constants/ActionTypes';
import axios from 'util/Api';

async function updateUser({ dispatch, values }) {
  dispatch({ type: UPDATE_LOADING, payload: true });

  try {
    const response = await axios.post('/api/v1/forgot-password', values);

    dispatch({ type: UPDATE_MESSAGE, payload: response.data.data });
  } catch (error) {
    dispatch({ type: UPDATE_ERROR, payload: 'Không thể khôi phục mật khẩu' });
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

async function fetchUserData({ dispatch, token }) {
  dispatch({ type: UPDATE_LOADING, payload: true });

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const response = await axios.get('/api/v1/me', config);

    dispatch({ type: SET_AUTH_DATA, payload: get(response, 'data.data', {}) });
  } catch (error) {
    const errorResponse = get(error, 'response.data.code', null);

    if (errorResponse === 'token_not_valid') {
      localStorage.removeItem('token');
      localStorage.removeItem('roles');
      localStorage.removeItem('user');
      localStorage.removeItem('pos');
      window.location.href = '/login';
    }
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

async function resetPasswordUser({ dispatch, payload, navigate }) {
  const { password, password_confirmation, uid, token } = payload;

  dispatch({ type: UPDATE_LOADING, payload: true });

  try {
    const response = await axios.post('api/v1/reset-password', {
      password,
      password_confirmation,
      uid,
      token,
    });

    dispatch({ type: UPDATE_MESSAGE, payload: get(response, 'data.message', '') });
    navigate('/login');
  } catch (e) {
    dispatch({ type: UPDATE_ERROR, payload: get(e, 'response.data.message', '') });
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

async function registerTenant({ dispatch, payload, navigate }) {
  dispatch({ type: UPDATE_LOADING, payload: true });

  try {
    await axios.post('/api/v1/tenants/register', payload);
    dispatch({
      type: UPDATE_MESSAGE,
      payload: 'Tạo tài khoản thành công! Vui lòng kiểm tra Email để kích hoạt tài khoản.',
    });
    navigate('/login');
  } catch (e) {
    dispatch({ type: UPDATE_ERROR, payload: get(e, 'response.data.errors.email', '') });
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

async function confirmUser({ dispatch, payload, navigate }) {
  try {
    dispatch({ type: UPDATE_LOADING, payload: true });

    const response = await axios.post('/api/v1/confirm', payload);
    const accessToken = get(response, 'data.data.refresh_token');
    const roles = get(response, 'data.data.user.roles');
    const user = get(response, 'data.data.user');

    localStorage.setItem('token', JSON.stringify(accessToken));
    localStorage.setItem('roles', JSON.stringify(roles));
    localStorage.setItem('user', JSON.stringify(user));
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    dispatch({ type: SET_AUTH_DATA, payload: user });
    dispatch({ type: SET_USER_TOKEN, payload: accessToken });
    navigate('/setup-store');
  } catch (e) {
    dispatch({ type: UPDATE_ERROR, payload: 'Không thể xác nhận tài khoản!' });
    navigate('/login');
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

async function updateUserData({ dispatch, error, data }) {
  if (error) {
    const errorResponse = get(error, 'response.data.code', null);

    if (errorResponse === 'token_not_valid') {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  }

  if (data) {
    dispatch({ type: SET_AUTH_DATA, payload: data.data });
  }
}

async function signIn({ dispatch, payload }) {
  try {
    dispatch({ type: UPDATE_LOADING, payload: true });

    const response = await axios.post('/api/v1/login', payload);
    const loginUser = response.data;
    const roles = get(loginUser, 'data.user.roles');

    localStorage.setItem('token', JSON.stringify(loginUser.data.access_token));
    localStorage.setItem('roles', JSON.stringify(roles));
    localStorage.setItem('user', JSON.stringify(loginUser.data.user));

    axios.defaults.headers.common.Authorization = `Bearer ${loginUser.data.access_token}`;

    dispatch({ type: SET_AUTH_DATA, payload: loginUser.data.user });
    dispatch({ type: SET_USER_TOKEN, payload: loginUser.data.access_token });
  } catch (e) {
    const errorCode = get(e, 'response.data.code', null);

    if (errorCode === 'not_active_account') {
      dispatch({ type: UPDATE_ERROR, payload: get(e, 'response.data.message', null) });
    } else {
      dispatch({ type: UPDATE_ERROR, payload: 'Đăng nhập sai email hoặc mật khẩu!' });
    }
  } finally {
    dispatch({ type: UPDATE_LOADING, payload: false });
  }
}

function hideMessage() {
  return { type: UPDATE_MESSAGE, payload: '' };
}

function updateAvatar({ dispatch, payload }) {
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const nextUser = currentUser ? { ...currentUser, avatar: payload } : null;

  if (nextUser) {
    localStorage.setItem('user', JSON.stringify(nextUser));
  }

  dispatch({ type: UPDATE_USER_AVATAR, payload });
}

export {
  updateUser,
  hideMessage,
  resetPasswordUser,
  signIn,
  registerTenant,
  updateUserData,
  confirmUser,
  updateAvatar,
  fetchUserData,
};
